import { Suspense } from 'react';

// project import
import { Loader } from './Loader';

// ==============================|| LOADABLE - LAZY LOADING ||============================== //

export const Loadable = (Component) => (props) => (
  <Suspense fallback={<Loader />}>
    <Component {...props} />
  </Suspense>
);
